export type TReportAuthorization =
  { status: 'ok'; authorization: string | undefined } | { status: 'missing' }

const isToken = (value: unknown): value is string =>
  typeof value === 'string' && value.length > 0

/** An undefined authorization lets the API layer use the session token. */
export const resolveReportAuthorization = (
  urlToken: unknown,
  sessionToken: string | null,
): TReportAuthorization => {
  if (isToken(urlToken)) return { status: 'ok', authorization: urlToken }
  if (isToken(sessionToken)) return { status: 'ok', authorization: undefined }
  return { status: 'missing' }
}
